import moment, { Moment } from 'moment';
import { ViewPresetId } from 'components/organisms/resource-management/scheduler-config/view-presets/constants';
import { ViewPreset } from 'components/organisms/resource-management/scheduler-config/view-presets/view-presets';

const commonPresetConfig = (relativeDate: Moment) => ({
  incrementBy: 'day',
  timeResolution: {
    unit: 'day',
    increment: 1,
  },
  rowHeight: 48,
  shiftUnit: 'day',
  shiftIncrement: 1,
  headers: [
    {
      unit: 'day',
      increment: 1,
      renderer: (startDate: Date) => {
        return moment(startDate).diff(relativeDate.startOf('day'), 'day');
      },
    },
  ],
});

const weekPresetConfig = (relativeDate: Moment) => ({
  incrementBy: 'day',
  timeResolution: {
    unit: 'day',
    increment: 1,
  },
  rowHeight: 48,
  shiftUnit: 'week',
  shiftIncrement: 1,
  headers: [
    {
      unit: 'week',
      increment: 1,
      align: 'start',
      renderer: (startDate: Date) => {
        return `<strong>Week ${
          moment(startDate).diff(relativeDate.startOf('week'), 'week') + 1
        }</strong>`;
      },
    },
    {
      unit: 'day',
      increment: 1,
    },
  ],
});

export const getZoomPresets = (relativeDate: Moment): ViewPreset[] => [
  {
    id: ViewPresetId.Day,
    ...commonPresetConfig(relativeDate),
    tickWidth: 40,
  },
  {
    id: ViewPresetId.DayZoomed,
    ...commonPresetConfig(relativeDate),
    tickWidth: 72,
  },
];

export const getZoomPresetsForHoursPerWeek = (
  relativeDate: Moment,
): ViewPreset[] => [
  {
    id: ViewPresetId.Week,
    ...weekPresetConfig(relativeDate),
    tickWidth: 24,
  },
  {
    id: ViewPresetId.WeekZoomed,
    ...weekPresetConfig(relativeDate),
    tickWidth: 36,
  },
];
